import { useEffect, useState } from "react"

/** No `matchMedia` outside a browser — SSR, or jsdom under Jest. */
const canMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"

/** Reactive `window.matchMedia` – re-renders when the query flips. */
const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() =>
    canMatchMedia() ? window.matchMedia(query).matches : false
  )

  useEffect(() => {
    if (!canMatchMedia()) return
    const media = window.matchMedia(query)
    const update = () => setMatches(media.matches)
    update()
    media.addEventListener("change", update)
    return () => media.removeEventListener("change", update)
  }, [query])

  return matches
}

export default useMediaQuery
